import React from "react";
import { Link } from "react-router-dom";

const TermsOfUse = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hearo-wrap hero-inner">
        <div className="container">
          <div className="bread-crum">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Terms of Use
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="container hero-bx padding-top-bot">
          <div className="row justify-content-center">
            <div className="col-md-7">
              <h1 className="hero-title">Terms of Use</h1>
              <p>
                Read our website usage agreement carefully before continuing.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="container aml-page sec-pad-t">
        <div class="row justify-content-center">
          <div class="col-sm-12 privacy-p">
            <h3>General</h3>
            <p>
              By using this website www.kittrowinvest.com (hereinafter – the
              “Website”), you agree with this Terms of Use. We reserve the right
              at any time in our sole discretion to modify any provisions of
              these Terms of Use without notice. You are responsible for
              periodically checking these Terms of Use for changes. Continued
              use of the Website after the posting of changes constitutes your
              acceptance of these changes. If you disagree with these terms – do
              not use the Website.
            </p>

            <h3>Website ownership</h3>
            <p>
              This Website is a property of Kittrow Investments s.r.o. 
              (hereinafter – the “Company” or “We”). Any download or any other
              kind of copying of software or materials on the Website shall not
              be construed as granting you either expressed or implied rights or
              licenses. Any materials downloaded by you to this Website become
              the property of the Company, and can be used by the Company for
              all purposes not prohibited by law and may also be published by
              the Company including the transfer of their existing legislative
              or supervisory authority under whose jurisdiction the Company is.
            </p>
            <p>
              The Company reserves all rights relating to copyright and the use
              of trademarks, and exercising those rights in full and within the
              limits of applicable law. The Company monitors compliance with
              copyright and other rights, the violation of which is punishable
              by law.
            </p>

            <h3>Services & products</h3>
            <p>
              The exact list of our products and services is specified on this
              Website, however from time to time we might offer additional
              services. All information provided on this Website in any case
              should not be understood as a public offer or any kind of
              agreement between you and the company working under trademark
              Kittrow Investments s.r.o. If you want to buy any product or receive any service
              from us, we should conclude a separate agreement.
            </p>
            <p>
              The agreement may be concluded on behalf of the Company however we
              reserve the right to conclude the agreement on behalf of another
              company that have necessary licenses or permissions for provision
              of services;
            </p>

            <h3>Access to the website</h3>
            <p>
              This Website or any information or materials contained herein are
              not directed or intended for distribution to or use by, any person
              or entity who is a citizen, resident or located in any
              jurisdiction in which such distribution, use, publication, or the
              ability to access contrary to the laws or regulations, or which
              prescribes the Company or any of its affiliates or otherwise
              related entities meet the requirements for registration or
              licensing within such jurisdiction.
            </p>

            <h3>The copyright</h3>
            <p>
              Unless otherwise specified, the materials in this Website,
              including (but not limited to) any graphic design, text,
              audio-visual and audio content, images and graphics are the
              exclusive property of the Company. Unless otherwise stated, these
              materials may not be copied, transmit, distribute, reproduce,
              sell, modify, display, save for later use, or use any other means,
              in whole or in part in any form or by any means, without the prior
              written consent of the Company.
            </p>

            <h3>Warranty and limitation of liability</h3>
            <p>
              Materials of web pages available to the user “as is”. the Company
              does not guarantee the accuracy of the materials provided herein,
              directly or indirectly, for any particular purpose and expressly
              disclaims any warranty of fitness for a particular purpose. The
              Company is not liable for any loss or damage resulting from the
              use of information released on this Website by third party.
            </p>
            <p>
              Despite the fact that every effort is made to ensure the accuracy
              of information posted on the Website, the Company cannot and will
              not guarantee the accuracy, reliability, timeliness or
              completeness of any information or data made available to you for
              any purpose. Neither the Company, nor any of its affiliates,
              directors, officers or employees, nor any independent agents or
              distributors are not liable for any loss or damage resulting from
              errors or failure in the operation of this Website, or as a result
              of acts or omissions of any other person involved in the creation,
              production and implementation of the Website, or if the contained
              data are not available for you, or for any other reason related to
              access, inability to access or use Website and of any material
              regardless of whether the Company or software providers or service
              providers control circumstances, this impacting or not.
            </p>
            <p>
              Under any circumstances or on any grounds at law or equity,
              whether the violation of the provisions of the contract,
              negligence or other wrongful conduct, direct obligation or any
              other basis, the Company shall not be liable for any indirect,
              consequential, incidental or punitive damages in connection with
              the use or inability to use this Website or any part of it, even
              if the Company has been advised of the possibility of such
              damages.
            </p>
            <p>
              All data presented on the Website are for informational purposes
              only and, therefore, cannot be taken as an offer or invitation for
              proposals addressed to anyone was out of the jurisdiction in which
              such offer or invitation is prohibited, as well as to whom
              direction of such offer or invitation would be unlawful, as well
              as should not be construed as a recommendation to buy, sell or
              otherwise any action with whatsoever specific investments.
            </p>
            <p>
              No material from this Website should not be construed and
              interpreted as investment advice by the Company, as well as any of
              its affiliates, directors, officers and employees. In any case,
              before making any decision on collaboration with the Company you
              are urged to consult with a professional legal, finance, tax or
              investment adviser.
            </p>

            <h3>Links to websites of third parties</h3>
            <p>
              Links to Websites of third parties are provided for your
              convenience only. The Company has no control over the content of
              these Websites owned or operated by third parties. Using these
              links, you will leave this Website. The Company disclaims all
              warranties, either expressed or implied, concerning the content of
              such Websites, including the adequacy, accuracy, timeliness or
              completeness of the materials therein, for any particular purpose.
              The company is not responsible if these Websites violate the
              rights of any third party, including copyright and trademark
              contain viruses or other harmful elements. the Company cannot
              guarantee the authenticity of the documents posted on the
              Internet. Links to Websites of third party do not constitute
              endorsement of opinions, ideas, products, information, or services
              offered on such sites, and therefore the Company is not liable for
              any third-party Websites.
            </p>

            <h3>Security</h3>
            <p>
              Please note that the information transmitted by email is never
              completely confidential and secure. Sending important and
              confidential unencrypted e-mail message, you assume the risks
              associated with the fact that any message or information posted on
              the Website may be read or intercepted by others.
            </p>

            <h3>Privacy</h3>
            <p>
              The Company pledges to keep your personal information. the Company
              and its affiliates may share this personal information with each
              other and will not disclose it to third parties, except if it is
              required by applicable law or court order.
            </p>
            <p>
              Tracking system for visitors of the Website may also collect
              information about the pages you visit, how did you hear about our
              website, about the frequency of visits, etc. Collected information
              is used to improve our website, and to contact you in any suitable
              way to keep you informed about what, in our opinion, may have an
              interest for you.
            </p>
            <p>
              We are GDPR compliant. Please find more information in our Privacy
              Policy;
            </p>

            <h3>Applicable law and jurisdiction</h3>
            <p>
              Your use of this Website signifies your agreement to the
              jurisdiction of the courts located in Denmark, for any
              claims related to these Terms of Use. If disputes arise you
              consent to the exclusive jurisdiction of the courts of Denmark.
              If any provision of these Terms of use is unlawful, void
              or ceases to have any effect, such provision shall be deemed
              severable and shall be construed in accordance with the provisions
              of applicable law. This provision shall not affect the validity
              and enforceability of any remaining provisions.
            </p>
          </div>
        </div>
        {/* <!--===================help section!=================--> */}
        <div className="sec-pad-t">
          <div className="swap-part help-faq">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-md-10">
                <h2>
                  Still have questions? <br />
                  We're here to help.
                </h2>
                <p>
                  Our support team is always ready to assist you. Reach out —
                  we’ll respond quickly and clearly.
                </p>
                <div className="button-group">
                  <Link to="/contact-us" className="btn lm-btn">
                    Contact support
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="sec-pad-t"></div>
    </>
  );
};

export default TermsOfUse;
